// Returns the minimum selectable date for a date range picker as { year, month },
// calculated by subtracting the given number of months from today.
export const getMinPrevDateForDateRangePicker = (monthAgo = 2) => {
    const minDate = new Date(
        new Date().setMonth(new Date().getMonth() - monthAgo)
    );
    return {
        year: minDate.getFullYear(),
        month: minDate.getMonth() + 1,
    };
};

// Converts minutes to milliseconds.
// e.g. 5 → 300000
export const getMinutesToMilliseconds = (min) => {
    return min * 60000;
};

// Adds the given number of weeks to a date (mutates and returns the date).
export const addWeeksToDate = (date, numberOfWeeks) => {
    const days = (numberOfWeeks * 7);
    return addDaysToDate(date, days);
};

// Adds the given number of days to a date (mutates and returns the date).
export const addDaysToDate = (date, numberOfDays) => {
    date.setDate(date.getDate() + numberOfDays);
    return date;
};

// Returns the absolute number of weeks between two dates.
export const getWeeksBetweenDates = (from, to) => {
    let diff = (from.getTime() - to.getTime()) / 1000;
    diff /= (60 * 60 * 24 * 7);
    return Math.abs(Math.round(diff));
};
